/* eslint-disable */
import { GetterTree } from "vuex";
import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { UserState } from "@/types/user";

const getters: GetterTree<UserState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new User();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((user) => User.toSelectItem(user))
      : [];
  },
};

export default getters;
